import type { Dispatch, SetStateAction } from "react";
import { PRIVACY_POLICY_URL } from "../constants";
import { useQuoteCopy } from "../i18n/QuoteCopyContext";
import type { FormState } from "../types";
import type { Errors } from "../validation";
import { ContactFields } from "./ContactFields";
import { Checkbox } from "./fields";
import { WizardPage } from "./WizardPage";

interface Props {
  form: FormState;
  setForm: Dispatch<SetStateAction<FormState>>;
  errors: Errors;
  hasErrors: boolean;
  onBlur: (id: string) => void;
  onBack: () => void;
  onContinue: () => void;
}

export function ContactDetailsStep({
  form,
  setForm,
  errors,
  hasErrors,
  onBlur,
  onBack,
  onContinue,
}: Props) {
  const copy = useQuoteCopy();
  return (
    <WizardPage title={copy.t("page.contact")} hasErrors={hasErrors} onBack={onBack} onContinue={onContinue}>
      <section className="nv-section">
        <h3 className="nv-section-title">{copy.t("page.contactSection")}</h3>
        <ContactFields form={form} setForm={setForm} errors={errors} onBlur={onBlur} />
        <Checkbox
          id="nv-privacy"
          className="nv-consent"
          checked={form.privacyConsent}
          onChange={(c) => setForm((f) => ({ ...f, privacyConsent: c }))}
          label={
            <>
              {copy.t("contact.privacyBefore")}
              <a
                href={PRIVACY_POLICY_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  window.open(PRIVACY_POLICY_URL, "_blank", "noopener,noreferrer");
                }}
              >
                {copy.t("contact.privacyLink")}
              </a>
              {copy.t("contact.privacyAfter")}
            </>
          }
          error={errors.privacyConsent}
        />
      </section>
    </WizardPage>
  );
}
